import { Box } from '@factorialco/deprecated-design-system'

const SelectionOverlay = () => (
  <Box
    className="bg-f1-background-selected"
    aria-hidden="true"
    style={{
      position: 'absolute',
      inset: '0',
      pointerEvents: 'none',
      zIndex: '2',
    }}
  />
)

export { SelectionOverlay }
